import "./bottom-links.scss";